module.exports = __webpack_public_path__ + "img/1440.af4b61e7.jpg";